import PropTypes from "prop-types";
import * as React from "react";
import { Accordion, TextInput, Typography } from "../../themeV2";
import styles from "./AddShopDialog.module.css";
import { ACTION } from "./addShopReducer";

const FIELDS = [
  { key: "firstName", label: "First Name", maxLength: 40, half: true },
  { key: "lastName", label: "Last Name", maxLength: 40, half: true },
  { key: "country", label: "Country", maxLength: 30, half: false },
  { key: "address", label: "Address", maxLength: 255, half: false },
  { key: "address2", label: "Address Line 2", maxLength: 255, half: false },
  { key: "city", label: "City", maxLength: 30, half: true },
  { key: "state", label: "State / Province", maxLength: 30, half: true },
  { key: "zipCode", label: "Zip / Postal Code", maxLength: 20, half: true },
];

function ShippingSection({ shipping, dispatch }) {
  const handleChange = React.useCallback(
    (field) => (e) =>
      dispatch({
        type: ACTION.SET_SHIPPING_FIELD,
        field,
        value: e.target.value,
      }),
    [dispatch],
  );

  return (
    <Accordion.Root>
      <Accordion.Item value="shipping">
        <Accordion.Header>
          <Accordion.Trigger>
            <Typography variant="title-md" as="span">
              Shipping address (optional)
            </Typography>
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Panel>
          <div className={styles.shippingGrid}>
            {FIELDS.map(({ key, label, maxLength, half }) => (
              <TextInput
                key={key}
                label={label}
                value={shipping[key]}
                maxLength={maxLength}
                onChange={handleChange(key)}
                className={half ? styles.shippingHalf : undefined}
              />
            ))}
          </div>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  );
}

ShippingSection.propTypes = {
  shipping: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default React.memo(ShippingSection);
